const getRows = (
  response?: PairCheckingAccountResponse | null
): GetCheckingAccountWithAccountInfoResponse[] => {
  if (!response) return []
  if (Array.isArray(response)) return response
  return Array.isArray(response.data) ? response.data : []
}

export const getWalletFromListResponse = (
  response?: PairCheckingAccountResponse | null,
  walletId?: string | null
): GetCheckingAccountWithAccountInfoResponse | undefined => {
  const rows = getRows(response)

  if (!rows.length) return undefined

  if (walletId) {
    return rows.find(row => row.id === walletId)
  }

  return rows[0]
}
